module.exports = __webpack_public_path__ + "static/media/cloud2.30331244.png";